import HttpService from "@/services/http-service";
import Carousel, {CarouselImage, SearchCarouselRequestParam} from "@/entities/carousel";
import { pageMapperBuilder, Paginated } from "@/pagination";
import AsyncPaginatedRequest from "@/services/async-paginated-request";
import { LazyAsyncIter } from "@/iterators";

export default class MicroSiteService extends HttpService {
    public listCarousels(
        params: SearchCarouselRequestParam
    ): AsyncIterator<Paginated<Carousel>> {
        const asyncReq = new AsyncPaginatedRequest<CarouselDTO>(
            "get",
            "carousels",
            params,
            undefined,
            this.httpClient
        )[Symbol.asyncIterator]();

        return new LazyAsyncIter(asyncReq).map(pageMapperBuilder(carouselFromDTO));
    }

    public async createCarousel(carousel: Carousel, image: File): Promise<void> {
        const config = {
            headers: { "content-type": "multipart/form-data" },
        };
        const formData = new FormData();
        formData.append("image", image);
        formData.append("title", carousel.title);
        formData.append("url", carousel.url);
        formData.append("active", carousel.active ? '1' : '0');
        await this.httpClient.post("/carousels", formData, config);
    }

    public async getCarousel(carouselId: number): Promise<Carousel> {
        const { data } = await this.httpClient.get(`carousels/${carouselId}`);
        return data;
    }

    public async updateCarousel(
        carouselId: number,
        carousel: Carousel,
        image: File | null
    ): Promise<void> {
        const config = {
            headers: { "content-type": "multipart/form-data" },
        };

        const formData = new FormData();
        formData.append("title", carousel.title);
        formData.append("url", carousel.url);
        formData.append("active", carousel.active ? '1' : '0');
        formData.append("_method", "PUT");
        if (image !== null) {
            formData.append("image", image);
        }
        await this.httpClient.post(`/carousels/${carouselId}`, formData, config);
    }

    public async deleteCarousel(carouselId: number): Promise<void> {
        await this.httpClient.delete(`/carousels/${carouselId}`);
    }
}

export interface CarouselDTO {
    id: number;
    title: string;
    url: string;
    active: boolean|number;
    carousel_image: CarouselImage;
}

export function carouselFromDTO(dto: CarouselDTO): Carousel {
    return new Carousel({
        id: dto.id,
        title: dto.title,
        url: dto.url,
        active:dto.active,
        carousel_image: dto.carousel_image,
    });
}
